import { Component, computed, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { AuthenticationService } from '../../authentication/authentication.service';

@Component({
  selector: 'app-profile',
  imports: [MatCardModule],
  templateUrl: './profile.component.html',
})
export class ProfileComponent {

  private authenticationService = inject(AuthenticationService);

  protected readonly viewModel = computed(() => {
    const user = this.authenticationService.currentUserState()?.user;

    return {
      displayName: user?.displayName ?? '',
      profileImageSrc: user?.photoUrl?.value ?? '',
    };
  });

  protected get vm() { return this.viewModel(); }

}
